import { http, HttpResponse, PathParams } from 'msw';
import { AccountApiPaths } from '../../../slices/account-api.slice';
import { emailAliases } from '../../data/userAliases';
import { apiUrl } from '../apiUrl';
import { composeServerError, validateOtp } from './shared';

const fetchUserAliasesMutation = http.get(apiUrl(AccountApiPaths.userAliases), async () =>
    HttpResponse.json({
        data: emailAliases
    })
);
const addAliasMutation = http.post(apiUrl(AccountApiPaths.addAlias), async () => HttpResponse.json());
const deleteAliasMutation = http.delete(apiUrl(AccountApiPaths.userAliases), async () => HttpResponse.json());
const primaryAliasMutation = http.put(apiUrl(AccountApiPaths.makePrimaryAlias), async () => HttpResponse.json());

const verifyAliasOtpMutation = http.post<PathParams, { otp: string }>(
    apiUrl(AccountApiPaths.verifyAliasOtp),
    async ({ request }) => {
        const body = await request.json();
        const { otp } = body;
        const error = validateOtp(otp);
        return error ? composeServerError(request, error) : new HttpResponse();
    }
);

export const aliasHandlers = [
    fetchUserAliasesMutation,
    addAliasMutation,
    primaryAliasMutation,
    deleteAliasMutation,
    verifyAliasOtpMutation
];
